import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ ]

    connect() {
       console.log("ALPHA!")
    }

    list(event) {
      const letter = event.currentTarget.innerText
      let url = `/providers/list_by_letter?letter=${letter}`

      fetch(url, { headers: {'Accept': 'text/plain' }})
      .then(response => response.text())
      .then((data) => {
          this.element.outerHTML = data
      })
    }
}